import request from '../router/request';

let categoriesMap = {};
let fetchPromise = null;

export async function getCategorySlug(codigo_grupo) {
    if (!codigo_grupo) return null;

    if (Object.keys(categoriesMap).length === 0) {
        if (!fetchPromise) {
            fetchPromise = request.post('/portal/listarGruposConhec').then(res => {
                const categories = res.data || [];
                categories.forEach(cat => {
                    let slug = cat.nome_grupo
                        .toLowerCase()
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, "")
                        .replace(/[^a-z0-9]+/g, '-');
                        
                    if (slug === 'engenharia' || slug === 'engenharias') {
                        slug = 'tecnologia';
                    }
                    if (slug === 'ciencias-da-saude') {
                        slug = 'saude';
                    }
                    
                    categoriesMap[cat.codigo_grupo] = slug;
                });
                return categoriesMap;
            }).catch(err => {
                console.error("Erro ao carregar categorias para mapeamento de capas:", err);
                return {};
            });
        }
        await fetchPromise;
    }
    
    return categoriesMap[codigo_grupo] || null;
}
